import React from 'react';
import { NavLink } from 'react-router-dom';
import { parseDashboardURL } from '@utils';

const DashboardLink = ({ dashboard, className = '', activeClassName = '' }) => (
  <NavLink
    key={dashboard.id}
    to={parseDashboardURL(dashboard)}
    className={({ isActive }) => (isActive ? `${className} ${activeClassName}` : className)}
    title={dashboard.name}
    id={`tab-${dashboard.name}`.toLowerCase()}
  >
    <span>{dashboard.name}</span>
  </NavLink>
);

export default DashboardLink;
